import './index.css'
import cn from 'clsx'

import React from 'react'

/**
 * @deprecated Use `Spinner` from `components/ds` instead.
 * @see {@link components/ds/Spinner}
 * @migration
 * - Replace `<Spinner />` with `<Spinner />` from components/ds
 * - The `style` prop is not supported; use Radix layout components for positioning
 * - The `paused` prop is not supported in the DS version
 * - The `red` prop is not supported; DS Spinner inherits theme colors
 *
 * A loading spinner component with customizable appearance and animation state
 * @param style - Inline styles to apply to the spinner
 * @param paused - Whether the spinner animation is paused (defaults to false)
 * @param red - Whether to use red color styling (defaults to false)
 * @returns A div element containing animated spinner cubes
 */
const Spinner = ({
  style,
  paused,
  red,
}: {
  style?: Record<string, any>
  paused?: boolean
  red?: boolean
}): React.ReactElement<'div'> => (
  <div
    className={cn('Spinner', {
      paused,
      red,
    })}
    style={style}
  >
    <div className="Spinner_Cube1" />
    <div className="Spinner_Cube2" />
  </div>
)

export default Spinner
